module.exports = __webpack_public_path__ + "img/6.d8dd0188.png";